﻿import {RefObject, useCallback} from "react";

export function useArrayOnChange<T extends HTMLElement>(ref: RefObject<T | null>, onChange: ((values: number[]) => void) | undefined): (() => void) | undefined {
	const callback = useCallback(function (): void {
		const parent = ref.current;
		if (!parent) {
			return;
		}

		const inputs = parent.querySelectorAll<HTMLInputElement>("input");
		const selected: number[] = [];
		for (let i = 0, l = inputs.length; i < l; ++i) {
			if (inputs[i].checked) {
				selected.push(i);
			}
		}

		onChange!(selected);
	}, [onChange]);

	return onChange ? callback : undefined;
}
